import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, TrendingDown, TrendingUp, X } from "lucide-react";

/** Unread dispatcher notices (rate schedule activated / reverted, …) as a dismissible strip. */
export default function DispatchNotices({ refreshKey }) {
  const [notices, setNotices] = useState([]);

  const load = () => api.get("/dispatch/notices", { params: { unread_only: true, limit: 5 } }).then(r => setNotices(r.data.notices)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);

  const dismiss = async (id) => {
    setNotices(n => id === "all" ? [] : n.filter(x => x.notice_id !== id));
    await api.post(`/dispatch/notices/${id}/read`).catch(() => {});
  };

  if (notices.length === 0) return null;
  return (
    <div data-testid="dispatch-notices" className="mx-4 md:mx-6 lg:mx-8 mt-3 mb-2 border border-[#D4AF37]/40 bg-[#D4AF37]/5">
      <div className="flex items-center justify-between px-4 py-2 border-b border-[#D4AF37]/20">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[#D4AF37]"><BellRing size={12}/> Rate notifications</div>
        {notices.length > 1 && <button data-testid="dispatch-notices-dismiss-all" onClick={() => dismiss("all")} className="text-[10px] uppercase tracking-[0.18em] text-[#A1A1AA] hover:text-[#F5F2EB]">Dismiss all</button>}
      </div>
      {notices.map(n => (
        <div key={n.notice_id} data-testid={`dispatch-notice-${n.notice_id}`} className="flex items-start gap-3 px-4 py-2.5 border-b border-white/5 last:border-b-0">
          {n.kind === "rate_reverted" ? <TrendingDown size={16} className="text-emerald-400 mt-0.5 shrink-0"/> : <TrendingUp size={16} className="text-[#D4AF37] mt-0.5 shrink-0"/>}
          <div className="flex-1 min-w-0">
            <div className="text-sm text-[#F5F2EB]">{n.title}</div>
            <div className="text-xs text-[#A1A1AA]">{n.body}</div>
          </div>
          <span className="text-[10px] text-[#71717A] shrink-0">{new Date(n.created_at).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</span>
          <button data-testid={`dispatch-notice-dismiss-${n.notice_id}`} onClick={() => dismiss(n.notice_id)} aria-label="Dismiss" className="text-[#71717A] hover:text-[#F5F2EB]"><X size={14}/></button>
        </div>
      ))}
    </div>
  );
}
